import React, { useEffect } from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import { getLogger } from '../../common/logger/logger';

type InternalErrorPageProps = {
  error?: Error;
};

const InternalErrorPage: React.FC<InternalErrorPageProps> = ({ error }: InternalErrorPageProps) => {
  const log = getLogger('InternalErrorPage');
  useEffect(() => {
    const maybeError = history.state?.error || JSON.stringify(error);
    maybeError && log.error(maybeError);
  });

  return (
    <PageWrapper title='Serverfehler'>
      <div className='margin-vertical-xl align-center'>
        <h1 className='margin-none'>Hinweis Interner Serverfehler</h1>
        <h5 className='margin-none'>Es ist ein Fehler aufgetreten.</h5>
        <div>
          <img
            alt='errorImage'
            src='//www.static-immobilienscout24.de/statpic/error-page/1b897f0c0bc19ff74d68346f75fdef25_IS24_ErrorPage.svg'
            onError={() => "this.src='//etc/designs/is24/img/immoscout24.png';this.onerror=null;"}
            style={{ height: 200 }}
          />
          <p className='font-bold margin-bottom-s'>
            Leider ist ein unerwartetes Problem aufgetreten. Bitte laden Sie die Seite erneut oder versuchen Sie es zu einem späteren Zeitpunkt
          </p>

          <p className='margin-bottom-l'>
            Ansonsten klicken Sie auf den Zurück-Button Ihres Browsers oder auf einen
            <br /> der unten angegebenen Links, um in unser Angebot zurück zu kommen.
          </p>
          <a href='/' className='button-primary margin-bottom-l'>
            Zur Startseite
          </a>
          <p>Vielen Dank für Ihr Verständnis!</p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default InternalErrorPage;
